import { render, staticRenderFns } from "./LienVietConfig.vue?vue&type=template&id=3fef2a00&"
import script from "./LienVietConfig.vue?vue&type=script&lang=js&"
export * from "./LienVietConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports